"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTopic = void 0;
const core = __importStar(require("../../../../core"));
exports.EventTopic = core.serialization.enum_([
    "agent:created",
    "agent:updated",
    "agent:deleted",
    "space:created",
    "space:updated",
    "space:deleted",
    "document:created",
    "document:updated",
    "document:deleted",
    "workbook:created",
    "workbook:updated",
    "workbook:deleted",
    "sheet:created",
    "sheet:updated",
    "sheet:deleted",
    "snapshot:created",
    "records:created",
    "records:updated",
    "records:deleted",
    "file:created",
    "file:updated",
    "file:deleted",
    "job:created",
    "job:updated",
    "job:deleted",
    "job:completed",
    "job:ready",
    "job:scheduled",
    "job:outcome-acknowledged",
    "job:parts-completed",
    "job:failed",
    "commit:created",
    "commit:updated",
    "commit:completed",
    "layer:created",
]);
